import {
  Image,
  LinkBox,
  Box,
  LinkOverlay,
  Text,
  Flex,
  Center,
  Container,
  Button,
} from '@chakra-ui/react'
import { FC, useContext } from 'react'
import { BsGear } from 'react-icons/bs'
import { PageEnum } from '..'
import { AppContext } from '../../../libs/context'
import { listModels } from '../../../utils/modelEngine/configuration'

interface IProps {
  setPage: React.Dispatch<React.SetStateAction<PageEnum>>
}

const PickModel: FC<IProps> = ({ setPage }) => {
  const context = useContext(AppContext)
  const { model } = context

  const modelsList = listModels(context)

  return (
    <Container>
      {modelsList.map(m => (
        <Box position="relative" maxW="sm">
          <Box position="absolute" top="5px" right="5px" w="auto" zIndex="2">
            <Button
              variant="ghost"
              colorScheme="brand"
              onClick={() => {
                if (m.id === model.current.id) {
                  setPage(PageEnum.ProductConfiguration)
                } else {
                  document.location.href = `/?p=${m.id}&landing=${PageEnum.ProductConfiguration}`
                }
              }}
            >
              <BsGear></BsGear>
            </Button>
          </Box>
          <LinkBox
            as="article"
            p="5"
            m="15px 5px"
            rounded="md"
            cursor="pointer"
            boxShadow="0 0 25px 0 rgb(136 136 136 / 20%)"
            {...(m.id === model.current.id && {
              border: '2px solid #AE3465',
            })}
          >
            <Flex>
              <Center w="40%" p="0 15px">
                <Image objectFit="contain" src={m.preview} alt={m.title} />
              </Center>
              <Box w="60%" p="15px">
                <LinkOverlay href={'/?p=' + m.id}>
                  <Text fontSize="lg">{m.title}</Text>
                  {m.dimensions && (
                    <Text fontSize="sm">
                      Dimensions: {m.dimensions.w} x {m.dimensions.h} x{' '}
                      {m.dimensions.d}
                    </Text>
                  )}
                </LinkOverlay>
              </Box>
            </Flex>
          </LinkBox>
        </Box>
      ))}
    </Container>
  )
}

export default PickModel
